/**
 * 3.2.1.2 객체 관리 설정 Store
 *
 * @since 2017-12-12
 * @author devp020
 */

import {i18n} from '~/plugins/i18n'
const initSelectData = () => {
  return {
    obj_mng_cm_uname: '',
    obj_mng_cm_desc: '',
    obj_mng_cm_dns_days_val: '1111111',
    obj_mng_cm_dns_sched_type: 1,
    obj_mng_cm_dns_sync_yn: 1,
    obj_mng_cm_dns_term: 30,
    selectHour: 0,
    selectMin: 0,
    obj_mng_cm_id: 0,
    obj_mng_cm_ip_expire_sync_yn: 1,
    obj_mng_cm_ip_expire_term: 30,
    obj_mng_cm_ip_expire_type: 1,
    device_id_list: [],
    device_list_name: ''
  }
}
export const state = () => ({
  // api url 목록
  apiUrl: {
    objectMgmtSettingsUrl: '/api/cm/objects/mng/cm'
  },
  selectData: initSelectData(),
  objectMgmtSettingsList: [],
  selectedData: {
    obj_mng_cm_id: ''
  },
  objectMgmtSettingsResult: null,
  postObjectMgmtSettingsResult: null,
  selectRowItem: {},
  errorMessage: null
})

export const mutations = {
  // Row DoubleClick
  setSelectRowItem (state, data) {
    state.selectRowItem = data
  },
  setSelectData (state, data) {
    const selectedRowData = data
    const timeVal = selectedRowData.obj_mng_cm_dns_time_val
    if (timeVal !== undefined) {
      if (timeVal.substring(0, 1) === 0) { // 시간 첫차리가 0일때
        selectedRowData.selectHour = Number(timeVal.substring(1, 2))
      } else {
        selectedRowData.selectHour = Number(timeVal.substring(0, 2))
      }
      if (timeVal.substring(2, 3) === 0) { // 분 첫자리가 0일때
        selectedRowData.selectMin = Number(timeVal.substring(3, 4))
      } else {
        selectedRowData.selectMin = Number(timeVal.substring(2, 4))
      }
    }
    const deviceInfo = selectedRowData.device_list
    let result = ''
    if (deviceInfo.length > 0) {
      const deviceName = deviceInfo[0].device_uname
      const deviceLen = deviceInfo.length
      if (deviceLen > 1) {
        // result = `${deviceName} 외 ${deviceLen - 1} 대`
        result = i18n.t('cmn.deviceTypeText', {name: deviceName, cnt: deviceLen - 1})
      } else if (deviceLen === 1) {
        result = `${deviceName}`
      } else {
        result = ''
      }
      selectedRowData.device_list_name = result
    }
    selectedRowData.device_id_list = deviceInfo.map(id => id.device_id)
    if (!selectedRowData.device_id_list) {
      selectedRowData.device_id_list = []
    }
    if (!selectedRowData.device_list_name) {
      selectedRowData.device_list_name = ''
    }
    state.selectData = selectedRowData
  },
  clearSelectData (state) {
    state.selectData = initSelectData()
  },
  // 객체 관리 통합 설정 조회
  mutObjectMgmtSettings (state, payload) {
    // state.objectMgmtSettingsList = payload.filter(item => {
    //   item.device_id_list = '<div>' + item.device_list.map(item => {
    //     return item.device_uname
    //   }).join('</div><div>') + '</div>'
    //   return item
    // })
    state.objectMgmtSettingsList = payload
  },
  // 객체관리 설정 추가 (빈설정)
  mutAddEmptySettings: (state, item) => {
    state.objectMgmtSettingsList.push(item)
  },
  // 객체 관리 통합 설정 추가 완료 처리, 수정처리
  mutPutObjectMgmtSettings (state, payload) {
    state.objectMgmtSettingsResult = payload
  },
  // 객체관리 설정 삭제
  mutDelObjectMgmtSettings (state, itemIndexList) {
    itemIndexList = itemIndexList.sort().reverse()
    for (const itemIndex of itemIndexList) {
      state.objectMgmtSettingsResult.splice(itemIndex, 1)
    }
  },
  // 객체 관리 통합 설정 사용 여부 설정
  mutPostObjectMgmtSettings (state, payload) {
    state.postObjectMgmtSettingsResult = payload
  },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  }
}

export const actions = {
  async applyObjectMgmtAction () {
    const result = await this.$axios.$put('/api/cm/objects/mng/cm/apply', null, {applyMsg: true, loading: true, successAlert: true})
    return result
  },
  async cancelObjectMgmtAction () {
    const result = await this.$axios.$put(`/api/cm/objects/mng/cm/cancel`, null, {cancelMsg: true, loading: true, successAlert: true})
    return result
  },
  // 객체 관리 통합 설정 조회
  async acsObjectMgmtSettings ({commit, state}, {selectedId}) {
    let res = {}
    try {
      if (selectedId === undefined) {
        selectedId = 0
      }
      res = await this.$axios.$get(`${state.apiUrl.objectMgmtSettingsUrl}/${selectedId}`, {successAlert: false})
      if (res.code === 'ok') {
        if (selectedId !== 0) {
          commit('setSelectData', res.result[0])
        } else {
          commit('mutObjectMgmtSettings', res.result)
        }
      } else {
        commit('mutObjectMgmtSettings', [])
      }
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res = {
        code: 'nok',
        result: {
          msg: error
        }
      }
      return res
    }
  },
  // 객체관리 설정 추가 (빈설정)
  async acsAddEmptySettings ({commit, state}) {
    const result = { error: null }
    try {
      const res = await this.$axios.$post(`${state.apiUrl.objectMgmtSettingsUrl}`, null, {successAlert: false})
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 객체 관리 통합 설정 추가 완료 처리, 수정처리
  async acsPutObjectMgmtSettings ({commit, state}) {
    const selectParam = state.selectData
    let timeHourVal = String(selectParam.selectHour)
    let timeMinVal = String(selectParam.selectMin)
    if (timeHourVal.length === 1) {
      timeHourVal = '0' + timeHourVal
    }
    if (timeMinVal.length === 1) {
      timeMinVal = '0' + timeMinVal
    }
    const timeResult = timeHourVal + timeMinVal
    selectParam.obj_mng_cm_dns_time_val = timeResult
    if (selectParam.device_id_list === undefined) {
      selectParam.device_id_list = []
    }
    const res = await this.$axios.$put(`${state.apiUrl.objectMgmtSettingsUrl}`, selectParam, {successAlert: false})
    return res
  },
  // 객체관리 설정 삭제
  async acsDelObjectMgmtSettings ({commit, state}, param) {
    const result = { error: null }
    let res = {}
    try {
      res = await this.$axios.$put(`${state.apiUrl.objectMgmtSettingsUrl}/multi`, param.idList, {successAlert: false})

      if (res.code === 'ok') {
        // commit('mutDelObjectMgmtSettings', param.idList)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
      res = {
        code: 'nok',
        result: {
          msg: error
        }
      }
      return res
    }
  },
  // 객체 관리 통합 설정 사용 여부 설정
  async acsPostObjectMgmtSettings ({commit, state}, payload) {
    const result = { error: null }
    try {
      const res = await this.$axios.$post(`${state.apiUrl.objectMgmtSettingsUrl}/multi`, payload)
      commit('mutPostObjectMgmtSettings', res)
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  async onEventRuleChkInputAxios ({commit, state}, param) {
    try {
      const data = await this.$axios.$post(`${state.apiUrl.objectMgmtSettingsUrl}/multi`, param, {loading: false, successAlert: false})

      if (data.code !== 'ok') {
        return false
      }
      return data
    } catch (error) {
      return error
    }
  }
}

export const strict = false
